import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.main`
  background: var(--right-panel-background-color);
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: ${rem(14)};
  grid-area: d;
  min-height: 0;
  min-width: 0;
  width: 100%;
`;

export default {
  Wrapper
};
